import axios from 'axios';
import { UserActionTypes } from './';

const endpoint = `${process.env.REACT_APP_ERP_API_HOST}/users`;

export function findUsers(page, perPage, order, ascDesc, search, callback, errorCallback) {
  let query = `?page=${page ? page : 1}&perPage=${perPage ? perPage : 20}`;

  if (order) query += `&order=${order}`;
  if (ascDesc) query += `&ascDesc=${ascDesc}`;
  if (search) query += `&search=${search}`;

  const request = axios.get(`${endpoint}${query}`);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: UserActionTypes.FIND,
    payload : request
  };
}

export function getUser(id, callback, errorCallback) {

  const request = axios.get(`${endpoint}/${id}`);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: UserActionTypes.GET,
    payload : request
  };
}

export function createUser(user, callback, errorCallback) {
  const request = axios.post(`${endpoint}`, user);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: UserActionTypes.CREATE,
    payload: request
  }
}

export function updateUser(user, callback, errorCallback) {
  const request = axios.put(`${endpoint}/${user.id}`, user);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: UserActionTypes.UPDATE,
    payload: request
  }
}

export function deleteUser(id, callback, errorCallback) {
  const request = axios.delete(`${endpoint}/${id}`);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: UserActionTypes.DELETE,
    payload: request
  }
}


export function patchUsers(users, callback, errorCallback) {

  const requests = users.map(i => {
    return axios.patch(`${endpoint}/${i.id}`, i.patchData);
  });

  const mainRequest = axios.all(requests);

  if (callback) {
      mainRequest.then((response) => callback(response));
  }

  if (errorCallback) {
      mainRequest.catch((error) => errorCallback(error));
  }

  return {
    type: UserActionTypes.PATCH_MULTIPLE,
    payload: requests
  }
}

export function getCurrentUser(token, callback, errorCallback) {

  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  const request = axios.get(`${endpoint}/current`);

  if (callback) {
      request.then((response) => callback(response));
  }

  if (errorCallback) {
      request.catch((error) => errorCallback(error));
  }

  return {
    type: UserActionTypes.GET_CURRENT,
    payload : request
  };
}



// WEBPACK FOOTER //
// ./src/actions/user.action.js